import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListWithCompanyPayload } from '@app-store/slices/sharedLists/listWithCompany'

interface TaskAction extends Action {
    payload: IListWithCompanyPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sharedLists.listWithCompany

function* listWithCompanySagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/companies/shared-lists/list-with-company`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result.data)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload?.sagaCB?.onFailure) payload.sagaCB.onError(error)
    }
}

function* listWithCompanySaga(): any {
    yield takeLatest<TaskAction>(onRequest, listWithCompanySagaTask)
}

export default listWithCompanySaga
